// extracted by mini-css-extract-plugin
module.exports = {"texts":"texts--LxGwP","texts__unit":"texts__unit--34DSu","texts__unit--last":"texts__unit--last--2I6ui","texts__unit-content":"texts__unit-content--2ej3O"};